export default __webpack_public_path__ + "static/media/image_upload.89a3deae.svg";